import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_CONTRACT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateContract extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = [];

  url = UPDATE_CONTRACT_URL;

  constructor(applicationId, applicationType, productId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId, applicationType, productId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
